var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_vm._v(" Офферы данной вакансии будут архивированы. Чтобы отменить изменения, выключите данную опцию. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }